import { render, staticRenderFns } from "./BuildTextBlock.vue?vue&type=template&id=1cd26080&scoped=true&"
import script from "./BuildTextBlock.vue?vue&type=script&lang=js&"
export * from "./BuildTextBlock.vue?vue&type=script&lang=js&"
import style0 from "./BuildTextBlock.vue?vue&type=style&index=0&id=1cd26080&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd26080",
  null
  
)

export default component.exports